<script>
  let { component: Component, componentProps, onClose } = $props();

  let dialogEl;

  const focusableSelector =
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

  function handleKeydown(e) {
    if (e.key === "Escape") {
      onClose();
      return;
    }
    if (e.key === "Tab" && dialogEl) {
      const focusable = dialogEl.querySelectorAll(focusableSelector);
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  function handleBackdropClick(e) {
    if (e.target === e.currentTarget) onClose();
  }

  $effect(() => {
    const previouslyFocused = document.activeElement;
    const focusable = dialogEl?.querySelector(focusableSelector);
    (focusable || dialogEl)?.focus();
    return () => {
      previouslyFocused?.focus?.();
    };
  });
</script>

<svelte:window onkeydown={handleKeydown} />
<div class="modal-backdrop in"></div>
<div class="modal in" tabindex="-1" role="dialog" style="display:block" onclick={handleBackdropClick}>
  <div class="modal-dialog" role="document">
    <div class="modal-content" bind:this={dialogEl} tabindex="-1">
      <Component {...componentProps} />
    </div>
  </div>
</div>
